import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

const stats = [
  { id: 1, label: "Streams", value: 500000 },
  { id: 2, label: "Followers", value: 120000 },
  { id: 3, label: "Shares", value: 25000 },
  { id: 4, label: "Playlists Added", value: 7500 },
];

const StreamingSocialStats = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="max-w-6xl mx-auto py-16 text-center">
      <h2 className="text-3xl font-bold text-yellow-400 mb-8">Streaming & Social Stats</h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
        {stats.map((stat) => (
          <motion.div
            key={stat.id}
            initial={{ opacity: 0, y: 20 }}
            animate={visible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: stat.id * 0.2 }}
            className="bg-gray-900 text-white p-6 rounded-lg shadow-lg"
          >
            <motion.h3 
              initial={{ opacity: 0 }}
              animate={visible ? { opacity: 1 } : {}}
              transition={{ duration: 1 }}
              className="text-4xl font-bold text-yellow-400"
            >
              {visible ? stat.value.toLocaleString() : "0"}
            </motion.h3>
            <p className="text-lg mt-2 text-gray-300">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default StreamingSocialStats;